import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Box, Button, Card, Grid, Icon, Text } from "~/components-shared";
import styled, { useTheme } from "styled-components";
import { BarController, BarElement, CategoryScale, Chart as ChartJs, LinearScale, Tooltip } from "chart.js";
import { Chart } from "react-chartjs-2";
import memberInsights from "~/charts/memberInsights";
import TopicFootprintSmall from "~/components/TopicFootprintSmall";
import StyledIcon from "~/components/StyledIcon";
import { helpers } from "~/lib/helpers";
ChartJs.register(BarController, CategoryScale, LinearScale, BarElement, Tooltip);
const InfoButton = styled(Button)`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
const StyledGrid = styled(Grid)`
  overflow: hidden;
  position: relative;
`;
const Scrollable = styled.div`
  overflow: auto;
  max-height: 480px;
`;
const RecentFootprintCard = _ref => {
  let {
    dateFrom,
    dateTo,
    widget,
    ...rest
  } = _ref;
  const {
    current,
    byDay,
    footprints
  } = widget.data;
  const [currPeriod, prevPeriod] = helpers.humanReadablePeriodDiff(dateFrom, dateTo);
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Text, {
    fontSize: 15,
    lineHeight: 17,
    s: {
      mb: 2
    }
  }, current, /*#__PURE__*/React.createElement(Text, {
    element: "h5",
    fontSize: 5,
    weight: "semiBold",
    display: "inline",
    s: {
      ml: 1
    }
  }, "FOOTPRINTS")), /*#__PURE__*/React.createElement(Box, {
    style: {
      height: "100px"
    },
    s: {
      mb: 3
    }
  }, /*#__PURE__*/React.createElement(Chart, _extends({
    id: "chart-js"
  }, memberInsights.footprintDistribution(theme, byDay, currPeriod, prevPeriod)))), footprints.length ? /*#__PURE__*/React.createElement(Scrollable, null, /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 1,
    template: "1fr",
    gap: 3,
    fullWidth: true,
    s: {
      mb: 6,
      pt: 2,
      pr: 5
    }
  }, footprints.map(footprint => /*#__PURE__*/React.createElement(TopicFootprintSmall, {
    key: footprint.id,
    footprint: footprint
  })))) : /*#__PURE__*/React.createElement(Grid, {
    cols: 1,
    justify: "center",
    s: {
      mt: 8
    }
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "footprint",
    color: "translucentPrimary"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    },
    align: "center",
    style: {
      maxWidth: "400px"
    }
  }, "No footprints found")), /*#__PURE__*/React.createElement(InfoButton, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Info",
    color: "translucentPrimary",
    display: "inline",
    fontSize: 3,
    lineHeight: 3,
    s: {
      p: 1,
      ml: 2
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 4,
    src: "infoOutline"
  })));
};
export default RecentFootprintCard;